import { PaymentApi } from '@linktivity/triplabo-taxi';

import config from '../config';

const payment = new PaymentApi(config);

export default payment;
